<template>
  <div>
    <v-row>
      <v-col v-for="(stat, key) in stats" cols="12" lg="2" :key="key">
        <v-alert border="left" colored-border :color="stat.color" class="text-center py-1">
          <div class="text-center" v-html="stat.text"></div>
          <div class="font-weight-bold" style="font-size: 2rem; line-height: 1.2">{{ stat.value }}</div>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Statistik',
  props: {
    value: {
      type: [Array, Object],
    },
  },
  computed: {
    stats() {
      return [
        {
          color: 'blue',
          text: 'Peserta <strong>TK / PAUD</strong>',
          value: this.value[1] || 0,
        },
        {
          color: 'red',
          text: 'Peserta <strong>SD</strong>',
          value: this.value[2] || 0,
        },
        {
          color: 'indigo',
          text: 'Peserta <strong>SMP</strong>',
          value: this.value[3] || 0,
        },
        {
          color: 'grey',
          text: 'Peserta <strong>SMA</strong>',
          value: this.value[4] || 0,
        },
        {
          color: 'green',
          text: 'Peserta <strong>SMK</strong>',
          value: this.value[5] || 0,
        },
        {
          color: 'orange',
          text: 'Peserta <strong>SLB</strong>',
          value: this.value[6] || 0,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
